// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos generales para la galería */
.gallery-wrapper {
  position: relative;
  width: 100%;
  margin: 0; /* Eliminar márgenes */
  padding: 0; /* Eliminar padding */
}
.gallery-wrapper.video-loaded .gallery-container {
  opacity: 1;
}
.gallery-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* Alinear todos los elementos al inicio (izquierda) */
  padding: 10px; /* Eliminar padding */
  margin: 0; /* Eliminar márgenes */
  width: 70%;
  box-sizing: border-box;
  position: relative;
  height: 100%;
  z-index: 10;
  background: transparent;
}

.gallery-background-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 9;
  /* Nueva propiedad para mejor renderizado */
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000;
}


.gallery-item {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Alinear el contenido del elemento a la izquierda */
  margin: 0; /* Ajustar márgenes laterales */
  padding-left: 0; /* Eliminar cualquier padding */
  position: relative;
  z-index: 1;
  flex-basis: calc(18% - 4px);
  text-align: left; /* Alineación del texto a la izquierda */  
}

.combined-link {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Alinear el contenido del enlace a la izquierda */
  text-decoration: none;
  color: #ffffff;
  font-family: "CreatoDisplay", sans-serif; /* Aplicar la fuente */
  padding-left: 0; /* Eliminar padding */
  margin-left: 0; /* Asegurar que no hay margen a la izquierda */
  transition: color 0.3s ease-in-out; /* Agregar transición suave */
}

.small-italic-gallery {
  font-family: "EB Garamond", "EB Garamond Placeholder", serif; /* Aplicar la fuente */
  font-size: 16px;
  font-style: italic;
  margin-right: 10px;
  color: #ffffff;
  transition: color 0.3s ease-in-out; /* Agregar transición suave */
}

.combined-link:hover,
.combined-link:hover .small-italic-gallery {
  color: #ffffff58;
}

.small-italic-title {
  font-family: "EB Garamond", "EB Garamond Placeholder", serif; /* Aplicar la fuente */
  font-size: 16px;
  font-style: italic;
  color: #ffffff;
  transition: color 0.3s ease-in-out; /* Agregar transición suave */
  font-weight: 0;
}
.small-italic-title-brands {
  font-family: "EB Garamond", "EB Garamond Placeholder", serif; /* Aplicar la fuente */
  font-size: 16px;
  font-style: italic;
  color: #000000;
  transition: color 0.3s ease-in-out; /* Agregar transición suave */
  font-weight: 0;
}
.small-italic-gallery {
  font-family: "EB Garamond", "EB Garamond Placeholder", serif; /* Aplicar la fuente */
  font-size: 16px;
  font-style: italic;
  margin-right: 10px;
  color: #ffffff;
  font-weight: 0;
}
.small-italic-gallery:hover {
  color: #ffffff58;
}

.large-link {
  font-size: 69px; /* Tamaño reducido */
  font-weight: 800; /* Usar el peso ExtraBold */
  text-align: left; /* Alinear el texto a la izquierda */
  margin-left: 0; /* Eliminar margen a la izquierda */
  white-space: nowrap; /* Evitar que el texto se vaya a la siguiente línea */
}
/* Estilos del footer para cuando se muestra la galería */
body.gallery-active .footer {
  color: white;
}

body.gallery-active .footer a {
  color: white;
}
body.gallery-active .footer a:hover {
  color: rgb(124, 123, 123);
}

body.gallery-active .social-link::after {
  background: rgba(255, 255, 255, 0.2);
}
body.gallery-active .footer .social-icon {
  filter: brightness(0) invert(1); /* Convierte el icono a blanco */
}

/* Media Query para dispositivos móviles */
@media (max-width: 768px) {
  .small-italic-gallery {
    font-size: 0.8rem;
    font-weight: 100;
  }
  .small-italic-title {
    margin-top: 10px;
    line-height: 0;
  }
  .small-italic-title-brands {
    line-height: 0;
  }
  .large-link {
    font-size: 2rem;
    line-height: 0;
  }

  .gallery-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .gallery-item {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
  }

  .combined-link {
    justify-content: flex-start;
  }

  .gallery-background-video {
    background-size: cover;
    background-attachment: scroll;
    height: 100vh;
  }
}

/* Ajuste específico para iPhone */
@media screen and (max-width: 768px) and (-webkit-min-device-pixel-ratio: 2) {
  .gallery-background {
    background-attachment: scroll; /* Cambia a scroll para evitar problemas en iPhone */
    background-size: cover;
    object-fit: cover;
    height: 100vh; /* Asegura que el fondo ocupe toda la pantalla */
  }
}
@supports (-webkit-touch-callout: none) {
  .gallery-background {
    height: 100vh;
    width: 100vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Gallery.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS,EAAE,sBAAsB;EACjC,UAAU,EAAE,qBAAqB;AACnC;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAE,sDAAsD;EACnF,aAAa,EAAE,qBAAqB;EACpC,SAAS,EAAE,sBAAsB;EACjC,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,2CAA2C;EAC3C,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B,EAAE,qDAAqD;EAClF,SAAS,EAAE,+BAA+B;EAC1C,eAAe,EAAE,+BAA+B;EAChD,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B,EAAE,mDAAmD;EAChF,qBAAqB;EACrB,cAAc;EACd,wCAAwC,EAAE,sBAAsB;EAChE,eAAe,EAAE,qBAAqB;EACtC,cAAc,EAAE,8CAA8C;EAC9D,kCAAkC,EAAE,6BAA6B;AACnE;;AAEA;EACE,4DAA4D,EAAE,sBAAsB;EACpF,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kCAAkC,EAAE,6BAA6B;AACnE;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,4DAA4D,EAAE,sBAAsB;EACpF,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kCAAkC,EAAE,6BAA6B;EACjE,cAAc;AAChB;AACA;EACE,4DAA4D,EAAE,sBAAsB;EACpF,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kCAAkC,EAAE,6BAA6B;EACjE,cAAc;AAChB;AACA;EACE,4DAA4D,EAAE,sBAAsB;EACpF,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,oBAAoB;EACrC,gBAAgB,EAAE,2BAA2B;EAC7C,gBAAgB,EAAE,oCAAoC;EACtD,cAAc,EAAE,mCAAmC;EACnD,mBAAmB,EAAE,qDAAqD;AAC5E;AACA,yDAAyD;AACzD;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,+BAA+B,EAAE,gCAAgC;AACnE;;AAEA,0CAA0C;AAC1C;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;EACf;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,6BAA6B,EAAE,oDAAoD;IACnF,sBAAsB;IACtB,iBAAiB;IACjB,aAAa,EAAE,gDAAgD;EACjE;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;EACd;AACF","sourcesContent":["/* Estilos generales para la galería */\n.gallery-wrapper {\n  position: relative;\n  width: 100%;\n  margin: 0; /* Eliminar márgenes */\n  padding: 0; /* Eliminar padding */\n}\n.gallery-wrapper.video-loaded .gallery-container {\n  opacity: 1;\n}\n.gallery-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start; /* Alinear todos los elementos al inicio (izquierda) */\n  padding: 10px; /* Eliminar padding */\n  margin: 0; /* Eliminar márgenes */\n  width: 70%;\n  box-sizing: border-box;\n  position: relative;\n  height: 100%;\n  z-index: 10;\n  background: transparent;\n}\n\n.gallery-background-video {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 9;\n  /* Nueva propiedad para mejor renderizado */\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  perspective: 1000;\n}\n\n\n.gallery-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; /* Alinear el contenido del elemento a la izquierda */\n  margin: 0; /* Ajustar márgenes laterales */\n  padding-left: 0; /* Eliminar cualquier padding */\n  position: relative;\n  z-index: 1;\n  flex-basis: calc(18% - 4px);\n  text-align: left; /* Alineación del texto a la izquierda */  \n}\n\n.combined-link {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; /* Alinear el contenido del enlace a la izquierda */\n  text-decoration: none;\n  color: #ffffff;\n  font-family: \"CreatoDisplay\", sans-serif; /* Aplicar la fuente */\n  padding-left: 0; /* Eliminar padding */\n  margin-left: 0; /* Asegurar que no hay margen a la izquierda */\n  transition: color 0.3s ease-in-out; /* Agregar transición suave */\n}\n\n.small-italic-gallery {\n  font-family: \"EB Garamond\", \"EB Garamond Placeholder\", serif; /* Aplicar la fuente */\n  font-size: 16px;\n  font-style: italic;\n  margin-right: 10px;\n  color: #ffffff;\n  transition: color 0.3s ease-in-out; /* Agregar transición suave */\n}\n\n.combined-link:hover,\n.combined-link:hover .small-italic-gallery {\n  color: #ffffff58;\n}\n\n.small-italic-title {\n  font-family: \"EB Garamond\", \"EB Garamond Placeholder\", serif; /* Aplicar la fuente */\n  font-size: 16px;\n  font-style: italic;\n  color: #ffffff;\n  transition: color 0.3s ease-in-out; /* Agregar transición suave */\n  font-weight: 0;\n}\n.small-italic-title-brands {\n  font-family: \"EB Garamond\", \"EB Garamond Placeholder\", serif; /* Aplicar la fuente */\n  font-size: 16px;\n  font-style: italic;\n  color: #000000;\n  transition: color 0.3s ease-in-out; /* Agregar transición suave */\n  font-weight: 0;\n}\n.small-italic-gallery {\n  font-family: \"EB Garamond\", \"EB Garamond Placeholder\", serif; /* Aplicar la fuente */\n  font-size: 16px;\n  font-style: italic;\n  margin-right: 10px;\n  color: #ffffff;\n  font-weight: 0;\n}\n.small-italic-gallery:hover {\n  color: #ffffff58;\n}\n\n.large-link {\n  font-size: 69px; /* Tamaño reducido */\n  font-weight: 800; /* Usar el peso ExtraBold */\n  text-align: left; /* Alinear el texto a la izquierda */\n  margin-left: 0; /* Eliminar margen a la izquierda */\n  white-space: nowrap; /* Evitar que el texto se vaya a la siguiente línea */\n}\n/* Estilos del footer para cuando se muestra la galería */\nbody.gallery-active .footer {\n  color: white;\n}\n\nbody.gallery-active .footer a {\n  color: white;\n}\nbody.gallery-active .footer a:hover {\n  color: rgb(124, 123, 123);\n}\n\nbody.gallery-active .social-link::after {\n  background: rgba(255, 255, 255, 0.2);\n}\nbody.gallery-active .footer .social-icon {\n  filter: brightness(0) invert(1); /* Convierte el icono a blanco */\n}\n\n/* Media Query para dispositivos móviles */\n@media (max-width: 768px) {\n  .small-italic-gallery {\n    font-size: 0.8rem;\n    font-weight: 100;\n  }\n  .small-italic-title {\n    margin-top: 10px;\n    line-height: 0;\n  }\n  .small-italic-title-brands {\n    line-height: 0;\n  }\n  .large-link {\n    font-size: 2rem;\n    line-height: 0;\n  }\n\n  .gallery-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .gallery-item {\n    width: 100%;\n    text-align: left;\n    margin-bottom: 15px;\n  }\n\n  .combined-link {\n    justify-content: flex-start;\n  }\n\n  .gallery-background-video {\n    background-size: cover;\n    background-attachment: scroll;\n    height: 100vh;\n  }\n}\n\n/* Ajuste específico para iPhone */\n@media screen and (max-width: 768px) and (-webkit-min-device-pixel-ratio: 2) {\n  .gallery-background {\n    background-attachment: scroll; /* Cambia a scroll para evitar problemas en iPhone */\n    background-size: cover;\n    object-fit: cover;\n    height: 100vh; /* Asegura que el fondo ocupe toda la pantalla */\n  }\n}\n@supports (-webkit-touch-callout: none) {\n  .gallery-background {\n    height: 100vh;\n    width: 100vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
